import styled from 'styled-components';

export const CustomTabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .wrap-tabs {
    flex: 1;
  }

  p {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    color: #383ecd;
  }

  .tab-line {
    padding: 0;
    div {
      background-color: #fd8a24;
    }
  }

  .es-tab-item {
    font-size: 16px;
    line-height: 22px;
  }
`;
